import Select from 'react-select'
import {custom_select_type} from './_module'
import {useTranslation} from 'react-i18next'

const CustomSelect = ({
  onChange,
  options,
  value,
  defaultValues,
  className,
  isLoading,
  isLoadTrueFalse,
  placeholderText,
  isMulti,
  isDisabled,
}: any) => {
  const {t} = useTranslation()

  const defaultValue = (options: any, value: any, isMulti: boolean) => {
    if (!options) return isMulti ? [] : ''

    if (isMulti) {
      return options.filter((option: any) => value?.includes(option.id))
    }

    return options.find((option: any) => option.id === value || option.name === value)
  }

  return (
    <div className={className}>
      <Select
        styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
        menuPortalTarget={document.body}
        key={options}
        placeholder={t('VALIDATION.SELECT_', {name: placeholderText})}
        value={defaultValue(options, value, isMulti)}
        defaultValue={defaultValues}
        onChange={(value) => {
          onChange(value ? value : '')
        }}
        options={options}
        getOptionLabel={(options: custom_select_type) => options.name}
        getOptionValue={(options: custom_select_type) => options.id}
        backspaceRemovesValue={true}
        isLoading={isLoadTrueFalse ? isLoading : false}
        isClearable={true}
        isSearchable={true}
        isMulti={isMulti}
        isDisabled={isDisabled}
      />
    </div>
  )
}

export default CustomSelect
